var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.recom-vouchers'),"text":_vm.$t('recomVouchers.description'),"name":"recomVouchers","url":_vm.$listRoutes.recomVouchers,"table":_vm.recomVouchers,"filters":_vm.recomVouchersFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }